export default (theme) => ({
    header: {
        '& > * + *': {
            marginTop: 8,
        },
    },
});
